module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.ch/it_ch/azienda/privacy.html",
	"footer.disclaimer.text": "Dichiarazione di non responsabilità",
	"footer.disclaimer.url": "https://www.grohe.ch/it_ch/azienda/note-legali.html",
	"footer.copyright": "&copy; 2017 GROHE Switzerland SA",
	"homepage.headline": "Configuratore di sistemi per la fornitura di acqua GROHE",
	"homepage.introtext": "Per configurare il sistema per la fornitura di acqua GROHE che soddisfi le tue esigenze, rispondi ad alcune domande di seguito. ",
	"homepage.buttonStart": "Inizia",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Pagina non trovata",
	"404.link.goBack": "Torna alla homepage ",
	"configurator.button.seeResults": "Visualizza i risultati",
	"question1.question": "Hai una fornitura di acqua calda e fredda nella tua cucina?",
	"question1.option1.text": "Ho una fornitura di acqua calda nella mia cucina",
	"question1.option2.text": "Ho una fornitura di acqua fredda con uno scaldaacqua istantaneo installato",
	"question2.question": "Che tipo di acqua cerchi?",
	"question2.option1.text": "Acqua bollente per preparare cibi e bevande",
	"question2.option2.text": "Acqua fresca e frizzante da bere",
	"question2.option3.text": "Acqua fresca e frizzante e acqua bollente",
	"question3.question": "Vuoi tenere il tuo rubinetto della cucina?",
	"question3.option1.text": "Voglio tenerlo",
	"question3.option2.text": "Voglio installare un nuovo modello",
	"question4.question": "Quale rubinetto principale desideri?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Qual è il tuo design della bocca preferito?",
	"question5.option1.text": "Bocca a L",
	"question5.option2.text": "Bocca a U",
	"question5.option3.text": "Bocca a C",
	"question6.question": "What's your prefered spout design for the GROHE Red Mono tap?",
	"question6.option1.text": "Bocca a L",
	"question6.option2.text": "Bocca a C",
	"question7.question": "Qual è la tua finitura preferita?",
	"question7.option1.text": "Cromato",
	"question7.option2.text": "Supersteel",
	"question8.question": "Di che dimensioni dev’essere il tuo bollitore?",
	"question8.option1.text": "Dimensione M",
	"question8.option2.text": "Dimensione L",
	"question9.question": "Desideri avere un filtro aggiuntivo per ammorbidire l’acqua e migliorarne la qualità?",
	"question9.option1.text": "Si",
	"question9.option2.text": "No",
	"results.title": "Your {productGroupsCount, plural, \none {Il tuo risultato} \nother {I tuoi risultati}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Per una corretta installazione, avrai bisogno anche di:",
	"results.newConfiguration.title": "Vuoi configurare un nuovo sistema di fornitura dell’acqua?",
	"results.newConfiguration.buttonText": "Configura un nuovo sistema di fornitura dell’acqua",
	"results.product.number": "Codice prodotto: #{number}",
	"results.product.button.productInformation": "Informazioni sul prodotto",
	"results.product.button.dealerLocator": "Trova uno showroom",
	"results.product.button.buyNow": "Acquista online",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informazioni sul prodotto",
	"results.product.dealer": "Trova uno showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.it_ch.json
// module id = 784
// module chunks = 0